import type { BeatTicketsItemProps } from './beat-tickets-item';

export const mockDefault: BeatTicketsItemProps = {
    locale: 'nl',
    eventTitle: 'event title',
    id: '1',
    dateFull: 'za 01.08.2024',
    date: '01 aug 2024',
    venueId: 'stadsschouwburg-antwerp',
    venueName: {
        nl: 'Stadsschouwburg Antwerp',
        en: 'Stadsschouwburg Antwerp',
        fr: 'Stadsschouwburg Antwerp',
    },
    times: [
        {
            id: '1',
            time: '10:00',
            cta: {
                url: 'https://www.teleticketservice.com/tickets/2022-2023/zillion',
                label: 'soldOut',
                isDisabled: false,
            },
            status: 'soldOut',
            name: '',
        },
    ],
};

export const mockWithReminder: BeatTicketsItemProps = {
    ...mockDefault,
    times: [
        {
            ...mockDefault.times[0],
            reminder: {
                date: '2023-02-22',
                time: '09:31',
                eventDate: '2023-02-22T09:31:29.731Z',
                originalDate: '2023-02-22T09:31:29.731Z',
            },
        },
    ],
};

export const mockFull: BeatTicketsItemProps = {
    ...mockDefault,
    id: '1',
    times: [
        { ...mockDefault.times[0], name: 'Spirou Charleroi vs Antwerp Giants' },
    ],
};
